module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-pagination-8c5a05496d33ff387a309eddaf8d6255.svg";